<div class="login-page">
  <div style="width: 100%;height:5%"></div>
  <mat-toolbar class="mat-toolbar-azul">
    <img [src]="logoVisorWeb" width="250" height="auto">
    <div class="text-container" fxHide.xs fxHide.sm>
      <span>Visor de Precios CIV-DL</span>
      <span>Colegio de Ingenieros de Venezuela</span>
    </div>
    <img [src]="logoColegioIngenieros" width="150" height="150" style="position: absolute; right: 0px; top: 10px;">
  </mat-toolbar>
  <div class="container" fxLayout="row" fxLayout.md="column" fxLayout.xs="column" fxLayout.sm="column"
    fxLayoutAlign="end strech">
    <div fxShow>

      <mat-card class="mat-elevation-z12" [ngClass]="classFlag ? 'card-login-mini' : 'card-login'">
        <mat-card-title class="card-title">----- Recuperar Contraseña-----</mat-card-title>

        <form [formGroup]="userForm" (ngSubmit)="validateUser()" *ngIf="hide">
          <!-- <ng-container> -->
            <p>Por favor ingrese su nombre de usuario</p>
            <mat-card-content>
              <mat-form-field class="full-width" appearance="outline">
                <input matInput formControlName="username" placeholder="Usuario" maxlength="100" autocomplete="off" required>
                <mat-icon matSuffix>person</mat-icon>
                <mat-error *ngIf="userForm.controls['username'].hasError('required')">
                  Usuario es requerido
                </mat-error>
                <mat-error *ngIf="userForm.controls['username'].hasError('minlength')">Usuario debe ser mínimo 03
                  caracteres.</mat-error>
              </mat-form-field>

            </mat-card-content>

            <mat-card-actions>
              <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
                class="div-conten-justify">
              <button routerLink="/login" mat-raised-button color="warn" type="submit" class="align-center-middle">
                <span class="text-icon-space">Regresar al Login</span>
                <mat-icon>exit_to_app</mat-icon>
              </button>
              <button mat-raised-button color="primary" type="submit" class="align-center-middle">
                <span class="text-icon-space">Continuar</span>
                <mat-icon>sync_lock</mat-icon>
              </button>
            </div>
            </mat-card-actions>
          <!-- </ng-container> -->
        </form>
        <form [formGroup]="userPasswordForm" (ngSubmit)="validatePassword()" *ngIf="!hide">
          <!-- <ng-container> -->
            <p class="item1">Ingrese la respuesta a la pregunta de seguridad y su nueva contraseña
              Si la respuesta es correcta, se asignará su nueva contraseña.</p>
            <p class="item2" style="font-size: 15px;">¿{{ randomQuestion }}?</p>

            <mat-card-content>
              <div fxLayoutAlign="space-around center" fxLayoutGap="10px" class="div-conten-center">
              <mat-form-field class="full-width" appearance="outline">
                <input matInput formControlName="pregunta" placeholder="Respuesta pregunta"
                  [type]="hideResponseQuestion ? 'password' : 'text'" maxlength="15" autocomplete="off" required>
                <mat-icon matSuffix (click)="hideResponseQuestion = !hideResponseQuestion">{{hideResponseQuestion ? 'visibility_off' :
                  'visibility'}}</mat-icon>
                <mat-error *ngIf="userPasswordForm.controls['pregunta'].hasError('required')">
                  La respuesta es requerida
                </mat-error>
                <mat-error *ngIf="userPasswordForm.controls['pregunta'].hasError('minlength')">La respuesta debe ser mínimo 04
                  caracteres.</mat-error>
              </mat-form-field>
            </div>
            
            <div fxLayout="row" fxLayoutAlign="space-around justify" fxLayout.sm="column" fxLayout.md="column" fxLayout.xs="column"
              class="div-conten-justify">
              <p><b> La contraseña debe cumplir con las siguientes especificaciones:</b> Mínimo 6 caracteres con al
                menos una letra en mayúscula, una letra en minúscula, un valor numérico y un carácter especial: # ? ! &#64; $ % & * .
              </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px" class="div-conten-justify">
              <div fxFlex>
              <mat-form-field class="full-width" appearance="outline">
                <input matInput formControlName="passwordForgot" placeholder="Nueva Contraseña"
                  [type]="hideTextPassword ? 'password' : 'text'" maxlength="15" required>
                <mat-icon matSuffix (click)="hideTextPassword = !hideTextPassword">{{hideTextPassword ? 'visibility_off' :
                  'visibility'}}</mat-icon>
                <mat-error *ngIf="userPasswordForm.controls['passwordForgot'].hasError('required')">
                  La contraseña es requerida
                </mat-error>
                <mat-error *ngIf="userPasswordForm.controls['passwordForgot'].hasError('minlength')">La contraseña debe ser mínimo 06
                  caracteres.</mat-error>
                <mat-error *ngIf="userPasswordForm.controls['passwordForgot'].hasError('pattern')">La contraseña no cumple
                  especificaciones.</mat-error>
              </mat-form-field>
            </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="0px" class="divconten-padding-top">
              <div fxFlex>
              <mat-form-field class="full-width" appearance="outline">
                <input matInput formControlName="confirmForgot" placeholder="Confime Contraseña"
                  [type]="hideTextConfirmPassword ? 'password' : 'text'" maxlength="15" required>
                <mat-icon matSuffix (click)="hideTextConfirmPassword = !hideTextConfirmPassword">{{hideTextConfirmPassword ?
                  'visibility_off' : 'visibility'}}</mat-icon>
                <mat-error *ngIf="userPasswordForm.controls['confirmForgot'].hasError('required')">
                  La confirmacion de contraseña es requerida
                </mat-error>
                <mat-error *ngIf="userPasswordForm.controls['confirmForgot'].hasError('minlength')">La contraseña debe ser mínimo 06
                  caracteres.</mat-error>
                <mat-error *ngIf="userPasswordForm.controls['confirmForgot'].hasError('pattern')">La contraseña no cumple
                  especificaciones.</mat-error>
                <mat-error
                  *ngIf="userPasswordForm.controls['confirmForgot'].hasError('mustMatch') && (userPasswordForm.controls['confirmForgot'].touched || userPasswordForm.controls['confirmForgot'].dirty ) && !userPasswordForm.controls['confirmForgot'].errors?.['required']">
                  Valores introducidos para las contraseñas deben coincidir.
                </mat-error>
              </mat-form-field>
            </div>
            </div>
            </mat-card-content>

            <mat-card-actions>
              <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
                class="div-conten-justify">
              <button routerLink="/login" mat-raised-button color="warn" type="submit" class="align-center-middle">
                <span class="text-icon-space">Regresar al Login</span>
                <mat-icon>exit_to_app</mat-icon>
              </button>
              <button mat-raised-button color="primary" type="submit" class="align-center-middle">
                <span class="text-icon-space">Cambiar Contraseña</span>
                <mat-icon>sync_lock</mat-icon>
              </button>
            </div>
            </mat-card-actions>

            <div>
              <p><a style="color: blue; text-decoration: underline;" (click)="forgotAnswers()">¿Olvidaste tus respuestas?</a></p>
            </div>

          <!-- </ng-container> -->

        </form>
        <mat-divider inset></mat-divider>
        <div class="margin-top-10px">
          <p>&#9400; Todos los derechos reservados</p>
        </div>
      </mat-card>



    </div>
  </div>
  <div style="width: 100%;height: 22%;"></div>
  <mat-toolbar style="background-color: transparent;justify-content: center;">
    <img [src]="logoDatalaing" width="250" height="auto">
  </mat-toolbar>
</div>
